import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "q-mb-md" }
const _hoisted_2 = { class: "q-mb-md" }
const _hoisted_3 = { class: "q-mb-md" }
const _hoisted_4 = { class: "q-mb-md" }
const _hoisted_5 = { class: "q-mb-md" }
const _hoisted_6 = { class: "q-mb-md" }
const _hoisted_7 = {
  key: 0,
  class: "q-mb-md"
}
const _hoisted_8 = { class: "flex full-width justify-end q-pa-md" }

import { PropType, ref, computed } from "vue";
  import { Platform, QCard, QExpansionItem } from "quasar";

  import { useCurrencyFormatter, EVENTS, logEvent} from "src/functions";
  import { useVehicleStore } from "src/stores/vehicle-store";
  import { useSettingsStore } from "src/stores/settings-store";

  import TermSelector from "src/components/form/buttons/TermSelector.vue";
  import CurrencyInput from "src/components/form/inputs/CurrencyInput.vue";
  import CreditProfileSelect from "src/components/form/inputs/CreditProfileSelect.vue";
  import { QuoteFilter } from "src/types/quote/index";
  import Dialog from "src/components/form/containers/Dialog.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'QuoteEditor',
  props: {
    filters: {
      type: Object as PropType<QuoteFilter>,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    showScore: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update'],
  setup(__props, { emit: __emit }) {

  const settingsStore = useSettingsStore();

  const isMobile = computed(() => settingsStore.isMobile);
  const showDialog = ref(false);

  const props = __props

  const emit = __emit
  function update() {
    showDialog.value = false;
    emit('update')
  }

  function openDialog() {
    showDialog.value = true;
  }

return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isMobile.value)
      ? (_openBlock(), _createBlock(_unref(QCard), {
          key: 0,
          bordered: "",
          clickable: "",
          onClick: openDialog
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item, { class: "full-width" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "text-subtitle2" }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("Customise Quote")
                  ])),
                  _: 1,
                  __: [9]
                }),
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, { name: "mdi-tune-variant" })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_resolveDynamicComponent(isMobile.value ? 'DialogContainer' : 'div'), {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showDialog).value = $event)),
      maximized: "",
      title: "Filter"
    }, {
      buttons: _withCtx(() => [
        _createVNode(_component_q_separator),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_q_btn, {
            outline: "",
            class: "brand-button",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (showDialog.value=false)),
            color: "primary"
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [
              _createElementVNode("span", { class: "" }, "Close", -1)
            ])),
            _: 1,
            __: [17]
          }),
          _createVNode(_component_q_btn, {
            label: "Update Quotes",
            onClick: update,
            color: "primary",
            loading: __props.loading,
            disable: __props.loading,
            class: "text-weight-bold brand-button q-ml-sm"
          }, null, 8, ["loading", "disable"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(QCard), {
          bordered: !isMobile.value,
          flat: isMobile.value,
          class: _normalizeClass(isMobile.value ? 'brand-app-bg full-height' : '')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(CurrencyInput, {
                    modelValue: __props.filters.price,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.filters.price) = $event))
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Price", -1)
                    ])),
                    _: 1,
                    __: [10]
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_2, [
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Mileage", -1)),
                  _createVNode(_component_q_input, {
                    outlined: "",
                    modelValue: __props.filters.mileage,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.filters.mileage) = $event)),
                    modelModifiers: { number: true },
                    "bg-color": "white",
                    "data-cy": "mileageInput",
                    rules: [val => (val !== null && val !== '') || 'Required', val => (val >= 0) || 'Must be greater than or equal to 0'],
                    type: "number",
                    "hide-spin-buttons": "",
                    min: "0",
                    dense: "",
                    value: "0"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(CurrencyInput, {
                    modelValue: __props.filters.deposit,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.filters.deposit) = $event))
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Deposit", -1)
                    ])),
                    _: 1,
                    __: [12]
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(CurrencyInput, {
                    modelValue: __props.filters.pxValue,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.filters.pxValue) = $event))
                  }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Part Ex. Value", -1)
                    ])),
                    _: 1,
                    __: [13]
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(CurrencyInput, {
                    modelValue: __props.filters.settlement,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((__props.filters.settlement) = $event)),
                    min: 0
                  }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Part Ex. Settlement", -1)
                    ])),
                    _: 1,
                    __: [14]
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(CurrencyInput, {
                    modelValue: __props.filters.annualMileage,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((__props.filters.annualMileage) = $event)),
                    hidePrefix: true
                  }, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Est. Annual Mileage", -1)
                    ])),
                    _: 1,
                    __: [15]
                  }, 8, ["modelValue"])
                ]),
                (__props.showScore)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(CreditProfileSelect, {
                        modelValue: __props.filters.creditScore,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((__props.filters.creditScore) = $event))
                      }, {
                        default: _withCtx(() => _cache[16] || (_cache[16] = [
                          _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Credit Profile", -1)
                        ])),
                        _: 1,
                        __: [16]
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (!isMobile.value)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      outline: "",
                      label: "Update Quotes",
                      onClick: update,
                      color: "primary",
                      loading: __props.loading,
                      disable: __props.loading,
                      class: "full-width text-weight-bold brand-button"
                    }, null, 8, ["loading", "disable"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["bordered", "flat", "class"])
      ]),
      _: 1
    }, 8, ["modelValue"]))
  ], 64))
}
}

})